import { css } from 'styled-components'
import { threads, white } from '@bufferapp/ui/style/colors'

import { threadsDarker } from '../../styles'
import {
  Video as CommonVideo,
  PlayButton as CommonPlayButton,
} from '../../../Common/VideoPlayer/styles'

export const Video = css`
  ${CommonVideo}
  border-radius: 12px;
`

export const PlayButton = css`
  ${CommonPlayButton}
  width: 40px;
  height: 40px;
  background-color: ${threads};
  border: 2px solid ${white};

  &:hover {
    background-color: ${threadsDarker};
    svg {
      fill: ${white};
      color: ${white};
    }
  }

  svg {
    fill: ${white};
    color: ${white};
    width: 30px;
    height: 30px;
  }
`

export const Wrapper = css`
  width: 100%;
  position: relative;

  video {
    ${Video}
  }

  button {
    ${PlayButton}
  }
`
